import { z } from 'zod'

export const CRM_AUTH_CONTRACT_VERSION = '1.0.0' as const

const crmAuthErrorSchema = z.object({
  code: z.string().min(1),
  message: z.string().min(1),
  reference: z.string().min(1),
}).passthrough()

export const crmAuthLegacyResponseSchema = z.object({
  contract_version: z.string().min(1),
  error: crmAuthErrorSchema.optional(),
}).passthrough()

export const crmAuthProfileResponseSchema = z.object({
  contract_version: z.literal(CRM_AUTH_CONTRACT_VERSION),
  user: z.object({
    id: z.string(),
    email: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    status: z.string().nullable(),
  }).passthrough(),
  memberships: z.array(z.object({
    orgId: z.string(),
    role: z.string().nullable(),
    status: z.string().nullable(),
  }).passthrough()),
  profileEvidence: z.record(z.unknown()),
  sideEffects: z.record(z.unknown()),
}).passthrough()

export type CrmAuthLegacyResponse = z.infer<typeof crmAuthLegacyResponseSchema>
export type CrmAuthProfileResponse = z.infer<typeof crmAuthProfileResponseSchema>
